// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"659d2b5a","453":"d4f5ed88","765":"39479487"}[chunkId] + ".chunk.js";
};